import React from 'react';
import styled from 'styled-components';

const Required = (props) => {
  const { required } = props;

  if (!required) {
    return false;
  }

  return <RequiredStyles>*</RequiredStyles>;
};

const RequiredStyles = styled.sup`
  color: var(--red);
`;

export default Required;
